import { createReducer, on } from '@ngrx/store';

import SettingsActions from './actions';
import { defaultSettingsState } from './state';

export const settingsReducer = createReducer(
    defaultSettingsState,
    on(SettingsActions.setOddAcceptance, (state, action) => {
        return {
            ...state,
            oddsAcceptance: action.acceptance,
        };
    }),
    on(SettingsActions.setAppNotify, (state, action) => {
        return {
            ...state,
            notifications: {
                ...state.notifications,
                appNotify: action.value,
            },
        };
    }),
    on(SettingsActions.setEmailNotify, (state, action) => {
        return {
            ...state,
            notifications: {
                ...state.notifications,
                emailNotify: action.value,
            },
        };
    }),
    on(SettingsActions.updateNotificationSettings, (state, action) => {
        return {
            ...state,
            oddsAcceptance: action.oddsAcceptance ?? state.oddsAcceptance,
            notifications: {
                ...state.notifications,
                emailNotify: action.emailNotify ?? state.notifications.emailNotify,
                appNotify: action.appNotify ?? state.notifications.appNotify,
            },
        };
    }),
);
